export const FLIGHT_MODEL_MANAGEMENT_COLUMNS_HEAD = [
  {
    title: "Serial No.",
    dataIndex: "serial_no",
    align: "left",
  },
  {
    title: "Flight Name",
    dataIndex: "name",
    align: "left",
  },
];

export const ADD_FLIGHT_MODEL_INITIAL_OBJECT = {
  name: "",
  errorFieds: {
    name: "",
  },
};
